import React, { Fragment, useEffect, useState } from "react";
import FullScreenSpinner from "../FullScreenSpinner/FullScreenSpinner";
import useAppState from "../StateMachine/useAppState";

const AccountProvider = ({ children }) => {
  const accountState = useAppState("account");
  const [isReady, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      accountState.getCurrentSession().then(_ => {
        setReady(true);
      });
    } else {
      setReady(true);
    }
  }, []);

  if (!isReady) {
    return <FullScreenSpinner txt="Fetching User Data" />;
  }

  // If user is an admin, then redirect them
  if (accountState.hasRole("Administrator")) {
    //window.location.href = `https://${process.env.REACT_APP_BASE_URL}/Admin`;
    window.location.href = `https://admin.plastx.co/`;
    return null;
  }

  // If user is an admin, then redirect them
  if (accountState.hasRole("CompanyAdmin")) {
    window.location.href = `https://${process.env.REACT_APP_BASE_URL}/Company`;
    return null;
  }

  return <Fragment>{children}</Fragment>;
};

export default AccountProvider;
